import { useCallback } from 'react';

export default function useWindowScroll() {
    return useCallback(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);
}
